import React from 'react';
import CardSearch from './CardSearch.tsx';
import Modal, { ModalBody } from './ui/Modal.tsx';

interface SearchModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SearchModal({ isOpen, onClose }: SearchModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Search Cards"
      size="md"
      closeOnBackdropClick={true}
      closeOnEscape={true}
    >
      <ModalBody>
        <CardSearch
          onClose={onClose}
          placeholder="Search by card name, ID, or number..."
          autoFocus={true}
        />

        <div className="mt-4 text-xs text-gray-400">
          <div className="flex gap-4">
            <span>↑↓ Navigate</span>
            <span>↵ Select</span>
            <span>Esc Cancel</span>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
